<template>
  <div>
    <b-row style="margin-bottom:5px">
      <b-col md="3" class="p-0 ml-1">
        <b-form-input
          v-model="item.numeroCamiseta"
          id="item-name"
          type="number"
          placeholder="#"
          size="sm"
          :style="`color:${item.color}`"
          @input="changeNumCamiseta"
          :disabled="estadoPartido == 'PJ' ? false : true"
        />
      </b-col>
      <b-col md="3" class="p-0" style="margin-left:5px">
        <b-form-input
          id="item-name"
          type="number"
          placeholder="Goles"
          size="sm"
          v-model="item.goles"
          @input="changeGoles"
          :disabled="item.disabled"
        />
      </b-col>

      <b-col
        v-if="partido.id_disciplina !== DISCIPLINAS.BALONCESTO"
        md="5"
        class="d-flex align-items-center"
      >
        <b-form-radio
          v-b-tooltip.hover.v-primary
          title="T. Amarilla"
          plain
          value="TA"
          v-model="item.tarjeta"
          :disabled="item.disabled"
        >
        </b-form-radio>
        <b-form-radio
          v-b-tooltip.hover.v-primary
          title="T. Roja"
          plain
          value="TR"
          v-model="item.tarjeta"
          :disabled="item.disabled"
        >
        </b-form-radio>
        <b-form-radio
          v-b-tooltip.hover.v-primary
          title="T. Roja por doble amarilla"
          plain
          value="DOBLE_TA"
          v-model="item.tarjeta"
          :disabled="item.disabled"
        >
        </b-form-radio>
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="flat-danger"
          class="btn-icon"
          size="sm"
          @click="deleteItem"
        >
          <feather-icon icon="XIcon" />
        </b-button>
        <div style="font-size:9px; background:gold">
          <!-- {{
            item.considerar == true && item.aplicada_sancion == 'n' ? 'N.A' : ''
          }} -->
          {{
            item.sancionado == true  ? 'Apli.' : ''
          }}
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BFormInput,
  //   BFormTextarea,
  //   BFormGroup,
  BFormRadio,
  //   BInputGroupPrepend,
  //   BInputGroup,
  //   BFormCheckbox,
  //   BAlert,
  BButton,
  VBTooltip,
  //   BSpinner,
  //   VBPopover,
  //   BAvatar,
  //   BPopover,
  //   BForm,
  //   BInputGroup,
  //   BInputGroupPrepend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  DISCIPLINAS,
  // xxx,
} from '../../utils/variables'

export default {
  components: {
    BRow,
    BCol,
    BFormRadio,
    BFormInput,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    item: Object,
    estadoPartido: String,
    partido: Object,
  },
  setup(props, { emit }) {
    function changeGoles() {
      emit('sumaGoles', props.item)
    }
    function changeNumCamiseta() {
      emit('verifyPlayer', props.item)
    }
    function deleteItem() {
      emit('deleteItem', props.item)
    }
    return {
      changeGoles,
      changeNumCamiseta,
      deleteItem,
      DISCIPLINAS,
    }
  },
}
</script>
